import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthLayout from '../layouts/AuthLayout';

const AuthGuard = ({ isAuthenticated, handleLogout, i18n, changeLanguage }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <AuthLayout handleLogout={handleLogout} i18n={i18n} changeLanguage={changeLanguage} />;
};

export default AuthGuard;
